import type { ReactNode } from 'react';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts/types';

import { useShortcutItemsConfig } from '../AppShortcuts/hooks/useShortcutItemsConfig.tsx';
import { useTeamsAppShortcut } from '../AppShortcuts/hooks/useTeamsAppShortcut.tsx';

export const useGlobalAppShortcuts = (): {
	shortcuts: Record<string, GlobalShortcutsItem>;
	createTeamModalComponent: ReactNode;
} => {
	const { config: teamsShortcutConfig, component: createTeamModalComponent } =
		useTeamsAppShortcut();
	const shortcuts = useShortcutItemsConfig({ teamsShortcutConfig });
	return { shortcuts, createTeamModalComponent };
};
